/**
 * Labor clocks on the receive order detail page (purchase order / transfer workspace).
 * The receive queue overview stays browse-only.
 */
export function inboundContainerLaborEnabled(input: {
  arrivalPackageId: string | null;
  wirePage: string;
}): boolean {
  void input.arrivalPackageId;
  return /^receiving-job:receive:(purchase_order|transfer_order):\d+$/iu.test(input.wirePage.trim());
}
